import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { AdminPanels } from '../shared/models/user.interface'
import { AdminService } from './admin.service';
import * as moment from 'moment';



@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

  public AdminPanelsInterface = AdminPanels;
  public selectedTab: any;
  public showSpinner: boolean = false;

  public tableData;
  public tableDataOfficer;
  public columnNames = {
    userName: 'User Name',
    role: 'Role',
  };

  constructor(
    private adminService: AdminService
  ) {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    }
  }

  ngOnInit(): void {
    this.selectedTab = 0;
    const currentUser = localStorage.getItem("currentUser");
    if (currentUser) {
      const currentUserId = JSON.parse(currentUser).id;
    }
  }
  selectTab(e) {
    console.log(e)
    this.selectedTab = e;
    // if (this.selectedTab == 1) {
    //   this.getOfficerStaff();
    // } 
    // else if (this.selectedTab == 0) {
    //   this.getVillageStaff()
    // }
  }

  // getVillageStaff() {
  //   this.showSpinner = true;
  //   this.adminService.getAllVillageStaff().subscribe(res => {
  //     this.showSpinner = false;
  //     if (res.userRoles.length > 0) {
  //       let users = [];
  //       res.userRoles.map((data: any) => {
  //         let user = {
  //           id: data.id,
  //           userName: data.user.userName,
  //           role: data.role.name,
  //           password: data.user.password
  //         }
  //         users.push(user)
  //       })
  //       this.tableData = users
  //     }
  //   })
  // }

  // getOfficerStaff() {
  //   this.showSpinner = true;
  //   this.adminService.getOfficerStaff().subscribe(res => {
  //     this.showSpinner = false;
  //     if (res.userRoles.length > 0) {
  //       let users = [];
  //       res.userRoles.map((data: any) => {
  //         let user = {
  //           id: data.id,
  //           userName: data.user.userName,
  //           role: data.role.name,
  //           password: data.user.password
  //         }
  //         users.push(user)
  //       })
  //       this.tableDataOfficer = users
  //     }
  //   })
  // }

  // ngOnDestroy() {
  //   console.log('backkkk');
  //   sessionStorage.removeItem('currentUser');
  //   localStorage.removeItem('currentUser');
  // }

}
